import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {IconBox} from '../../../../../../../../../../src/components/common/iconBox/iconBox';
import {fontWeights} from '../../../../../../../../../shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../../../../../../shared/ui/src/theme/userThemeProvider';

/*
 * Constants.
 */

const borderRadius = 16;
const iconName = 'warningFilledSmall';

export enum ErrorWarningBoxTypesEnum {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

/*
 * Props.
 */

export interface ErrorWarningBoxProps {
  type: ErrorWarningBoxTypesEnum;
  title: ReactNode;
  descriptionList?: ReactNode;
  descriptionText?: ReactNode;
  addtlDescription?: ReactNode;
}

/*
 * Style.
 */

const StyledErrorBoxDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledErrorTitleDiv = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: 13px;
  color: ${(p) => p.theme.greys.shade90};
  margin-bottom: 8px;
`;

const StyledErrorMessageUnorderedList = styled.ul`
  margin: 0 0 0 17px;
  padding: 0;
  color: ${(p) => p.theme.greys.shade80};
  font-size: 12px;
  line-height: 16px;
  list-style-position: outside;
  li {
    margin-bottom: 2px;
  }
`;

const StyledErrorMessageTextDiv = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${(p) => p.theme.greys.shade80};
`;

/*
 * Component.
 */

export const ErrorWarningBox: FC<ErrorWarningBoxProps> = ({
  title,
  descriptionList,
  descriptionText,
  addtlDescription,
  type,
}) => {
  const theme = useUserTheme();

  return (
    <IconBox
      iconName={iconName}
      borderRadius={borderRadius}
      backgroundColor={
        type === ErrorWarningBoxTypesEnum.WARNING ? theme.palette.orange.shade20 : theme.palette.red.shade20
      }
      iconColor={
        type === ErrorWarningBoxTypesEnum.WARNING ? theme.palette.orange.shade40 : theme.palette.red.shade40
      }
    >
      <StyledErrorBoxDiv>
        <StyledErrorTitleDiv>{title}</StyledErrorTitleDiv>
        {maybeRenderDescription(descriptionList, descriptionText)}
        {addtlDescription}
      </StyledErrorBoxDiv>
    </IconBox>
  );
};

/*
 * Helpers.
 */

function maybeRenderDescription(descriptionList?: ReactNode, descriptionText?: ReactNode) {
  if (descriptionList) {
    return <StyledErrorMessageUnorderedList>{descriptionList}</StyledErrorMessageUnorderedList>;
  }
  if (descriptionText) {
    return <StyledErrorMessageTextDiv>{descriptionText}</StyledErrorMessageTextDiv>;
  }
  return null;
}
